import { Model } from '../../infra/model'
import { observable, makeObservable } from 'mobx'
import { Id } from '../../types/definitions'
import { DateZero, maybeParseDate } from '../../utils/date-util'
import { InsightPropsDto } from './dtos'
import { timestampToISO } from 'utils/grpc-util'

/**
 * An Insight for a job.
 */
export class Insight extends Model<InsightPropsDto, Insight> {
  jobId = Id.none
  prefixContent = ''
  generatedResponse = ''
  id = Id.none
  dateGenerated = DateZero()
  isIrrelevant = false
  dateMarkedIrrelevant? = DateZero()

  constructor() {
    super()
    makeObservable(this, {
      jobId: observable,
      prefixContent: observable,
      generatedResponse: observable,
      id: observable,
      dateGenerated: observable,
      isIrrelevant: observable,
      dateMarkedIrrelevant: observable,
    })
  }

  parse(attrs: Partial<InsightPropsDto>): Partial<Insight> {
    const dateGeneratedString = timestampToISO(attrs.generatedTime)
    const dateMarkedIrrelevantString = timestampToISO(
      attrs.dateMarkedIrrelevant,
    )
    return {
      jobId: attrs.jobId,
      prefixContent: attrs.prefixContent,
      generatedResponse: attrs.generatedResponse,
      id: attrs.insightId,
      dateGenerated: maybeParseDate(dateGeneratedString),
      isIrrelevant: attrs.isIrrelevant,
      dateMarkedIrrelevant:
        maybeParseDate(dateMarkedIrrelevantString) ?? undefined,
    }
  }
}
